define("auth/controllers/application", ["exports", "@ember/controller", "@ember/object", "@ember/service"], function (_exports, _controller, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let UserController = (_class = class UserController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "session", _descriptor4, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
    }

    get childRouteName() {
      const path = this.router.currentRouteName.split('.');
      return path ? path[path.length - 1] : 'otherPages';
    }

    get isAuthenticated() {
      return this.session.isAuthenticated;
    }

    get isCreatingAccount() {
      return this.childRouteName === 'signup';
    }

    get isResettingPassword() {
      return this.childRouteName === 'update_password';
    }

    get isTrialPlans() {
      return this.childRouteName === 'trial_plans';
    }

    get childRoutePageTitle() {
      var _this$auth$currentAcc;

      const {
        hasActiveTrial
      } = this.subscriptions;
      const isEligibleForTrial = (_this$auth$currentAcc = this.auth.currentAccount) === null || _this$auth$currentAcc === void 0 ? void 0 : _this$auth$currentAcc.canTrialPlan;
      const trialPlansTitle = isEligibleForTrial ? this.intl.t('authorization.sign_up_trial.page_title') : '';
      const pageTitles = {
        login: this.intl.t('authorization.sign_in_form.title'),
        signup: this.intl.t('authorization.create_account.page_title'),
        forgot_email: this.intl.t('authorization.forgot_email_page.page_title'),
        reset_password: this.intl.t('authorization.forgot_password.page_title'),
        update_password: this.intl.t('shared_phrases.reset_password'),
        trial_plans: hasActiveTrial ? this.intl.t('authorization.sign_up_trial.page_title_active') : trialPlansTitle,
        'o-auth': this.intl.t('authorization.oauth.page.title'),
        'user-goals': this.intl.t('authorization.user_goals.page.title'),
        otherPages: ''
      };
      return pageTitles[this.childRouteName];
    }

    logout() {
      this.auth.logout();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "logout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype)), _class);
  _exports.default = UserController;
});